var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.7493 9.03151C18.0743 9.03151 18.3327 8.77318 18.3327 8.44818V7.67318C18.3327 4.25651 17.291 3.21484 13.8743 3.21484H6.12435C2.70768 3.21484 1.66602 4.25651 1.66602 7.67318V8.06484C1.66602 8.38984 1.92435 8.64818 2.24935 8.64818C2.99935 8.64818 3.60768 9.25651 3.60768 10.0065C3.60768 10.7565 2.99935 11.3565 2.24935 11.3565C1.92435 11.3565 1.66602 11.6148 1.66602 11.9398V12.3315C1.66602 15.7482 2.70768 16.7898 6.12435 16.7898H13.8743C17.291 16.7898 18.3327 15.7482 18.3327 12.3315C18.3327 12.0065 18.0743 11.7482 17.7493 11.7482C16.9993 11.7482 16.391 11.1398 16.391 10.3898C16.391 9.63984 16.9993 9.03151 17.7493 9.03151Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 13.2331C12.0332 13.2331 11.6582 12.8581 11.6582 12.3997C11.6582 11.9414 12.0332 11.5664 12.4915 11.5664C12.9499 11.5664 13.3249 11.9414 13.3249 12.3997C13.3249 12.8581 12.9665 13.2331 12.4999 13.2331Z",
    fill: "#FCFCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49987 9.0651C7.0332 9.0651 6.6582 8.6901 6.6582 8.23177C6.6582 7.77344 7.0332 7.39844 7.49154 7.39844C7.94987 7.39844 8.32487 7.77344 8.32487 8.23177C8.32487 8.6901 7.96654 9.0651 7.49987 9.0651Z",
    fill: "#FCFCFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19128 13.6922C7.03294 13.6922 6.87461 13.6339 6.74961 13.5089C6.50794 13.2672 6.50794 12.8672 6.74961 12.6255L12.3579 7.01719C12.5996 6.77552 12.9996 6.77552 13.2413 7.01719C13.4829 7.25885 13.4829 7.65885 13.2413 7.90052L7.63294 13.5089C7.51628 13.6339 7.34961 13.6922 7.19128 13.6922Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickDiscount);
export default __webpack_public_path__ + "static/media/tick-discount.a3f9eab174d208037ec4e15937d9899d.svg";
export { ForwardRef as ReactComponent };